<template>
    <div class="clue3-wrap">
        <img src="../assets/images/clue3/clue3.jpg" class="clue3" alt="clue3">
    </div>
</template>

<script>
export default {
    name: "clue3",

    components: {

    },
    data: () => ({
    }),
    created() {
    },
    mounted() {

    },
    watch: {

    },
    computed: {

    },
    methods: {

    },
};
</script>

<style lang="scss" scoped>
.clue3-wrap {
    position: absolute;
    width: 100%;
    height: 100%;

    .clue3 {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}
</style>
